import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import { withRouter } from 'react-router-dom';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import DatePicker from 'material-ui/DatePicker';
import areIntlLocalesSupported from 'intl-locales-supported';


import {
    green700,
    red700,
} from 'material-ui/styles/colors';

import {
    Grid,
    Icon,
} from '../../components';
import {
    pessoaService,
    Utils,
    areaService,
    subeventoService
} from '../../services';

const styles = {
    content: {
        padding: 16,
    },
    toggle: {
        maxWidth: 250,
    },
};

const arrayMoveMutate = (array, from, to) => {
    array.splice((to < 0 ? array.length + to : to), 0, array.splice(from, 1)[0]);
};

const arrayMove = (array, from, to) => {
    array = array.slice();
    arrayMoveMutate(array, from, to);
    return array;
};

let DateTimeFormat;


class InscricaoStepAutores extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsAutores: [],
            isPosting: false,
            nome: '',
            email: '',
            orientador: false,
            emailErrorText: 'Campo obrigatório',
            informacoesArea: {},
            desabilitaAvancar: true,
            enableDigitarNome: true,
            idade: null,
            emailResponsavel: '',
            cpf: '',
            nomeresp: '',
            cpfresp: '',
            enviatermo: '',
            codVeri: ''
        };

        if (areIntlLocalesSupported(['fr', 'fa-IR'])) {
            DateTimeFormat = global.Intl.DateTimeFormat;
        } else {
            const IntlPolyfill = require('intl');
            DateTimeFormat = IntlPolyfill.DateTimeFormat;
            require('intl/locale-data/jsonp/fr');
            require('intl/locale-data/jsonp/fa-IR');
        }

        this.buscaTiposSubmissao(this.props.subevento);
    }

    onDateChange(idade, email) {
        this.setState({ idade });

        idade = this.calculaIdade(idade, new Date());
        console.log(this.props);
        if (idade >= 18 || (this.props.instituicao == 'SETREM' && !this.state.enviatermo)) {
            this.setState({ emailResponsavel: email, cpfresp: this.state.cpf, nomeresp: this.state.nome });
        }
    }

    calculaIdade(nascimento, hoje) {
        if (!nascimento)
            return 0
        return Math.floor(Math.ceil(Math.abs(nascimento.getTime() - hoje.getTime()) / (1000 * 3600 * 24)) / 365.25);
    }

    async buscaTiposSubmissao(subevento) {
        const tiposSubmissao = await subeventoService.getSubevento(subevento);
        this.setState({ enviatermo: tiposSubmissao.ENVIATERMO });
    }

    async componentWillMount() {
        await this.buscarQuantidadeAutores(this.props.area);
    }

    async buscarQuantidadeAutores(area) {
        const informacoesArea = await areaService.getArea(area);
        this.setState({ informacoesArea });
    }

    async enviaCodConfirmacao() {
        var mail = this.state.emailResponsavel
        subeventoService.sendVerifyCode(this.props.subevento, mail);
    }

    async buscarPessoaPeloEmail(value) {
        const pessoa = await pessoaService.getNomeByValue(value.trim());
        if (pessoa.length !== 0) {
            this.setState({ nome: pessoa[0].NOME, enableDigitarNome: false });
        } else {
            this.setState({ enableDigitarNome: true });
        }
    }

    validarEmail(value) {
        if (!Utils.isEmailValido(value)) {
            this.setState({ emailErrorText: 'E-mail inválido.', email: value });
            return false;
        }
        this.setState({ emailErrorText: '', email: value });
        return true;
    }

    validarEmailRes(value) {
        if (!Utils.isEmailValido(value)) {
            this.setState({ emailErrorText: 'E-mail inválido.', emailResponsavel: value });
            return false;
        }
        this.setState({ emailErrorText: '', emailResponsavel: value });
        return true;
    }

    async verificaPodeAvancar(dsAutores) {
        const { informacoesArea } = this.state;
        const orientadores = dsAutores.filter(x => x.ORIENTADOR);
        const autores = dsAutores.filter(x => !x.ORIENTADOR);

        const habilitar =
            (autores.length >= informacoesArea.MINAUTORES && autores.length <= informacoesArea.MAXAUTORES)
            &&
            (orientadores.length >= informacoesArea.MINORIENTADORES && orientadores.length <= informacoesArea.MAXORIENTADORES);
        this.setState({ desabilitaAvancar: !habilitar });
    }

    async adicionarAutor(event) {
        event.preventDefault();
        const {
            nome,
            email,
            orientador,
            dsAutores,
            informacoesArea,
            idade,
            emailResponsavel,
            cpf,
            nomeresp,
            cpfresp,
            codVeri
        } = this.state;

        const orientadores = dsAutores.filter(x => x.ORIENTADOR);
        const autores = dsAutores.filter(x => !x.ORIENTADOR);

        if (!orientador && autores.length === informacoesArea.MAXAUTORES) {
            Utils.showToast(`Você já informou o número máximo de ${informacoesArea.MAXAUTORES} autor(es).`);
            return;
        }

        if (orientador && orientadores.length === informacoesArea.MAXORIENTADORES) {
            Utils.showToast(`Você já informou o número máximo de ${informacoesArea.MAXORIENTADORES} orientador(es).`);
            return;
        }

        if (!orientador && !idade) {
            Utils.showToast(`Data de Nascimento é obrigatório quando o autor é um aluno`);
            return;
        }

        if (cpf.length != 11) {
            Utils.showToast(`CPF deve ter 11 caracteres`);
            return;
        }

        if (cpfresp.length != 11) {
            Utils.showToast(`CPF do responsável deve ter 11 caracteres`);
            return;
        }

        const checkemail = await subeventoService.checkVerifyCode(this.props.subevento, emailResponsavel, codVeri);

        if(!checkemail.message && !orientador && this.state.enviatermo){
            Utils.showToast(`OPS! O seu código verificador não é esse.`);
            return;
        }

        if (dsAutores.map(x => x.EMAIL).indexOf(email) > -1) {
            return;
        }
        this.setState({
            dsAutores: dsAutores.concat({
                NOME: nome,
                EMAIL: email,
                ORIENTADOR: orientador,
                NASCIMENTO: idade,
                EMAILRESPONSAVEL: emailResponsavel,
                NASCIMENTOSTRING: idade ? idade.toLocaleDateString('pt-BR') : '',
                CPFRESPONSAVEL: cpfresp,
                NOMERESPONSAVEL: nomeresp,
                CPF: cpf
            }),
            nome: '',
            email: '',
            enableDigitarNome: true,
            idade: null,
            emailResponsavel: '',
            cpf: '',
            cpfresp: '',
            nomeresp: '',
            orientador: false,
            codVeri: ''
        }, () => {
            this.verificaPodeAvancar(this.state.dsAutores);
            this.emailRef.focus();
        });
    }

    async excluirAutor(autor) {
        const autores = this.state.dsAutores.slice();
        if (autores.indexOf(autor) > -1) {
            autores.splice(autores.indexOf(autor), 1);
            this.setState({ dsAutores: autores });
        }
        this.verificaPodeAvancar(autores);
    }

    async upAutor(autor) {
        const autores = this.state.dsAutores.slice();
        if (autores.indexOf(autor) >= 1) {
            this.setState({
                dsAutores: arrayMove(this.state.dsAutores, autores.indexOf(autor), autores.indexOf(autor) - 1),
            });
        }
    }

    async downAutor(autor) {
        const autores = this.state.dsAutores.slice();
        if (autores.indexOf(autor) < autores.length) {
            this.setState({
                dsAutores: 
                
                
                (this.state.dsAutores, autores.indexOf(autor), autores.indexOf(autor) + 1),
            });
        }
    }

    render() {
        const {
            dsAutores,
            isPosting,
            nome,
            email,
            cpf,
            emailErrorText,
            desabilitaAvancar,
            informacoesArea,
            enableDigitarNome,
            idade,
            emailResponsavel,
            cpfresp,
            nomeresp,
            enviatermo,
            orientador,
            codVeri
        } = this.state;
        var ver = (orientador || !this.state.enviatermo) ? true : codVeri;
        const isTodosCamposValidos = !!nome && !emailErrorText && ver;

        return (
            <div style={styles.content}>
                <form onSubmit={e => this.adicionarAutor(e)}>
                    <p>Insira todos os autores e orientadores do trabalho. <b>A ordem abaixo será a mesma mostrada no certificado.</b></p>
                    <div style={{ fontSize: 12 }}>
                        <p>Minímo autores: {informacoesArea.MINAUTORES}; Máximo autores: {informacoesArea.MAXAUTORES}</p>
                        <p>Minímo orientadores: {informacoesArea.MINORIENTADORES}; Máximo orientadores: {informacoesArea.MAXORIENTADORES}</p>
                    </div>
                    <TextField
                        ref={(ref) => { this.emailRef = ref; }}
                        type="email"
                        floatingLabelText="E-mail do autor"
                        required
                        errorText={!email ? 'Campo obrigatório' : emailErrorText}
                        onChange={e => this.validarEmail(e.target.value)}
                        onBlur={e => this.buscarPessoaPeloEmail(e.target.value)}
                        value={email}
                    />
                    <br />
                    <TextField
                        disabled={!enableDigitarNome}
                        floatingLabelText="Nome do autor"
                        required
                        errorText={nome ? '' : 'Campo obrigatório'}
                        onChange={e => this.setState({ nome: e.target.value })}
                        value={nome}
                    />
                    <br />
                    <TextField
                        floatingLabelText="CPF"
                        required
                        errorText={cpf ? '' : 'Campo obrigatório'}
                        onChange={e => this.setState({ cpf: e.target.value, idade: null })}
                        value={cpf}
                    />
                    <br />
                    <Toggle
                        label="É orientador?"
                        style={styles.toggle}
                        defaultToggled={false}
                        toggled= {orientador}
                        onToggle={(e, checked) => {
                            this.setState({
                                orientador: checked,
                                emailResponsavel: this.state.email,
                                cpfresp: this.state.cpf,
                                nomeresp:this.state.nome
                            })
                        }}
                    />
                    <br />
                    <DatePicker
                        hintText="Data de Nascimento"
                        locale="pt-BR"
                        errorText={!idade && !this.state.orientador ? 'Campo obrigatório' : ''}
                        DateTimeFormat={DateTimeFormat}
                        onChange={(event, t) => this.onDateChange(t, email)}
                        value={idade}
                        disabled={this.state.orientador}
                    />
                    <TextField
                        ref={(ref) => { this.emailRef = ref; }}
                        type="email"
                        floatingLabelText="E-mail do responsável"
                        required
                        errorText={!emailResponsavel ? 'Campo obrigatório' : emailErrorText}
                        onChange={e => this.validarEmailRes(e.target.value)}
                        value={emailResponsavel}
                        disabled={(this.props.instituicao == 'SETREM' && !enviatermo) || this.calculaIdade(idade, new Date()) >= 18 || this.state.orientador}
                    />
                    <br />
                    <br />
                    <TextField
                        disabled={(this.props.instituicao == 'SETREM' && !enviatermo) || this.calculaIdade(idade, new Date()) >= 18 || this.state.orientador}
                        floatingLabelText="Nome do responsável"
                        required
                        errorText={nomeresp ? '' : 'Campo obrigatório'}
                        onChange={e => this.setState({ nomeresp: e.target.value })}
                        value={nomeresp}
                    />
                    <br />
                    <TextField
                        disabled={(this.props.instituicao == 'SETREM' && !enviatermo) || this.calculaIdade(idade, new Date()) >= 18 || this.state.orientador}
                        floatingLabelText="CPF do responsável"
                        required
                        errorText={cpfresp ? '' : 'Campo obrigatório'}
                        onChange={e => this.setState({ cpfresp: e.target.value })}
                        value={cpfresp}
                    />
                    <br/>
                    <br />
                    <RaisedButton
                        label="Enviar email com o código de verificação"
                        primary
                        onClick={() => this.enviaCodConfirmacao()}
                        disabled={this.state.emailResponsavel == '' || this.state.orientador || !this.state.enviatermo}
                    /> 
                    <br />
                    <TextField
                        disabled={this.state.emailResponsavel == '' || this.state.orientador || !this.state.enviatermo}
                        floatingLabelText="Código de Verificação"
                        required
                        errorText={nomeresp ? '' : 'Campo obrigatório'}
                        onChange={e => this.setState({ codVeri: e.target.value })}
                        value={codVeri}
                    />
                     <br />
                     <br />
                    <RaisedButton
                        label="Adicionar Autor"
                        primary
                        type="submit"
                        disabled={isPosting || !isTodosCamposValidos}
                    />
                </form>
                <br />

                <Grid
                    rowsPerPage={20}
                    columnSortDefault={0}
                    textTableEmpty="Nenhum autor relacionado."
                    showSearch={false}
                    dataSource={dsAutores}
                    columns={[
                        {
                            text: 'Ordem de importância',
                            name: item => (
                                <div>
                                    <IconButton onClick={() => this.upAutor(item)} >
                                        <Icon name="arrow_upward" color={green700} />
                                    </IconButton>

                                    <IconButton onClick={() => this.downAutor(item)} >
                                        <Icon name="arrow_downward" color={red700} />
                                    </IconButton>
                                </div>
                            ),
                        },
                        {
                            text: 'Nome', name: 'NOME', allowSearch: true, searchOperator: 'LIKE',
                        },
                        {
                            text: 'E-mail', name: 'EMAIL', allowSearch: true, searchOperator: 'LIKE',
                        },
                        {
                            text: 'Orientador', name: row => (row.ORIENTADOR ? 'Sim' : 'Não'), allowSearch: true, searchOperator: 'LIKE',
                        },
                        {
                            text: 'Data de Nascimento', name: 'NASCIMENTOSTRING', allowSearch: true, searchOperator: 'LIKE',
                        },
                        {
                            name: item => (
                                <div style={{ textAlign: 'center' }}>
                                    <RaisedButton onClick={() => this.excluirAutor(item)} label="EXCLUIR AUTOR" secondary />
                                </div>
                            ),
                        },
                    ]}
                />
                <div>
                    <RaisedButton
                        label="Avançar"
                        primary
                        onClick={() => this.props.onInformarAutores(dsAutores)}
                        disabled={desabilitaAvancar}
                    />
                </div>
            </div>
        );
    }
}

InscricaoStepAutores.propTypes = {
    onInformarAutores: PropTypes.func.isRequired,
    area: PropTypes.number.isRequired,
};

export default withRouter(InscricaoStepAutores);
